import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const METRIKA_COUNTER_ID = 113891282;

/**
 * Отправляет просмотр страницы в Яндекс.Метрику при переходах внутри SPA.
 * Первый просмотр уже учитывается при инициализации счётчика в index.html.
 */
export default function MetrikaPageTracker() {
  const location = useLocation();
  const lastTrackedUrl = useRef<string | null>(null);

  useEffect(() => {
    const currentUrl = window.location.href;

    if (lastTrackedUrl.current === null) {
      lastTrackedUrl.current = currentUrl;
      return;
    }

    if (lastTrackedUrl.current === currentUrl) {
      return;
    }

    lastTrackedUrl.current = currentUrl;

    window.ym?.(METRIKA_COUNTER_ID, 'hit', currentUrl, {
      referer: document.referrer,
      title: document.title,
    });
  }, [location.pathname, location.search, location.hash]);

  return null;
}
